import cn from 'classnames';
import {useFormikContext} from 'formik';
import {ChangeEvent, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {RootState} from '../../store/redux';
import {addRegisterAdvertisement} from '../../store/redux/advertisementRegisteration';
type TabKey = 'description' | 'combinations' | 'application_method';

type TabsType = {key: TabKey; label: string}[];

const TABS: TabsType = [
  {key: 'description', label: 'توضیحات'},
  {key: 'combinations', label: 'ترکیبات'},
  {key: 'application_method', label: 'روش مصرف'},
];

// this component is suitable for formikContext + redux
const TabbedDescriptionTextarea = () => {
  const dispatch = useDispatch();
  const state = useSelector(
    (state: RootState) => state.advertisementRegisteration,
  );
  const {setFieldValue, errors, touched} = useFormikContext<any>();
  const [activeTab, setActiveTab] = useState<TabKey>('description');

  const activeTabConfig = TABS.find(t => t.key === activeTab)!;

  const handleChange = (e: ChangeEvent<HTMLTextAreaElement>) => {
    setFieldValue(activeTabConfig.key, e.target.value);
    dispatch(
      addRegisterAdvertisement({
        [activeTabConfig.key]: e.target.value,
      }),
    );
  };

  const error = String(errors[activeTab] ? errors[activeTab] : '');

  const isTouched = Boolean(touched[activeTab]);
  const textAreaStyle = Boolean(error)
    ? {
        borderColor: '#E90000',
        borderWidth: '1px',
      }
    : {borderColor: '#858a91', borderWidth: '1px'};
  return (
    <section>
      {/* Tabs */}
      <div className="flex gap-6 mb-2">
        {TABS.map(tab => (
          <button
            key={tab.key}
            type="button"
            onClick={() => setActiveTab(tab.key)}
            className={cn(
              'py-1 font-medium text-md rounded',
              Boolean(errors[tab.key]) && 'text-red-400',
              activeTab === tab.key ? ' text-farm-shop-500' : ' text-gray-700',
            )}
          >
            {tab.label}
          </button>
        ))}
      </div>

      {/* Textarea */}

      <textarea
        id={`text-area-${activeTabConfig.key}`}
        rows={5}
        style={textAreaStyle}
        className={cn('p-2 w-full rounded outline-none text-md')}
        placeholder={activeTabConfig.label + ' ' + 'محصول را بنویسید'}
        value={state[activeTabConfig.key] || ''}
        onChange={handleChange}
      />
      {isTouched && error && (
        <>
          <div className="pt-1 text-sm">
            {/* <small className={styles['text-area__input-icon__invalid']}>
                <i className="icon-warning"></i> {errors}
              </small> */}
            <span className="text-xs text-red-500">
              <i className="icon-warning"></i> {error}
            </span>
          </div>
        </>
      )}
    </section>
  );
};

export default TabbedDescriptionTextarea;
